const FIXED_TIME = 10
export default {
  data() {
    return {
      // 导出参数配置:
      exportObj: {
        excelTitleArray: [],
        excelFieldArray: [],
        contextMenuWrap: [],
        sortProp: '',
        sortOrder: ''
      },
      computedTime: FIXED_TIME
    }
  },
  methods: {
    batchExport(listName) {
      let tableColumn = listName['tableColumns']
      let excelTitleArray = []
      let excelFieldArray = []
      tableColumn.forEach((item) => {
        if (item.prop === 'rowNumber') return false
        excelTitleArray.push(item.label)
        excelFieldArray.push(item.prop)
      })
      this.exportObj.excelTitleArray = excelTitleArray
      this.exportObj.excelFieldArray = excelFieldArray
      let tableQuery = listName['tableQuery']
      for (let key in tableQuery) {
        this.exportObj[key] = tableQuery[key]
      }
      this.exportByPage()
      // if (this.computedTime === FIXED_TIME) {
      // } else {
      //   this.$message({ message: '您的操作过于频繁，请稍后再试', type: 'error' })
      // }
    },
    setExportByPage() {
      this.exportByPage()
      this.timer = setInterval(() => {
        this.computedTime--
        if (this.computedTime === 0) {
          clearInterval(this.timer)
          this.computedTime = FIXED_TIME
        }
      }, 1000)
    }
  }
}
